export default __webpack_public_path__ + "static/blob3-0b6e14afd772c88ffa427afbee1b44a9.svg";